import i18n from '../config/i18n';

export const t = i18n.getFixedT();
